var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-pagination',{attrs:{"background":"","current-page":_vm.currentPageL,"page-sizes":_vm.pageSizesL,"page-size":_vm.pageSizeL,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.totalL},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }